import {createRouter, createWebHistory} from "vue-router";
import DefaultView from "@/components/DefaultView.vue";
import SecurityView from "@/components/SecurityView.vue";
import HomeView from "../views/HomeView.vue";

import Dashboard from "@/views/App/Dashboard/Admin/Dashboard.vue";
import routesDashboardAdmin from "./Dashboard/Admin";
import DashboardCoach from "@/views/App/Dashboard/Coach/DashboardCoach.vue";
import DashboardAssistantVQ from "@/views/App/Dashboard/AssistantVQ/DashboardAssistantVQ.vue";
import DashboardPersonal from "@/views/App/Dashboard/HR/DashboardPersonal.vue";
import routesDashboardPersonal from "./Dashboard/HR";

import Calendar from "../views/App/Calendar/Calendar.vue";
import AddressBookDefaultView from "@/views/App/AddressBook/AddressBookDefaultView.vue";
import TimeManagementDefaultView from "@/views/App/TimeManagement/TimeManagementDefaultView.vue";
import OfficeDefaultView from "@/views/App/Office/OfficeDefaultView.vue";
import routesAddressBook from "./AddressBook";
import routesTimeManagement from "./TimeManagement";
import routesOffice from "./Office";
import routesAuth from "./Auth";
import ClientDefaultView from "@/views/App/Client/ClientDefaultView.vue";
import routesClient from "@/router/Client";
import routesMeetingRoom from "@/router/MeetingRoom";
import MeetingRoomDefaultView from "@/views/App/MeetingRoom/MeetingRoomDefaultView.vue";
import UnemployedDefaultView from "@/views/App/Unemployed/UnemployedDefaultView.vue";
import RegionDefaultView from "@/views/App/Region/RegionDefaultView.vue";
import routesRegion from "@/router/Region";
import CoursePrivateCoachingDefaultView from "@/views/App/Course/PrivateCoaching/CoursePrivateCoachingDefaultView.vue";
import routesCoursePrivateCoaching from "@/router/Course/PrivateCoaching";
import SendEmailDefaultView from "@/views/App/SendEmail/SendEmailDefaultView.vue";
import routesSendEmail from "@/router/SendEmail";
import CoursePrivateCoachingModuleDefaultView
    from "@/views/App/Course/PrivateCoachingModule/CoursePrivateCoachingModuleDefaultView.vue";
import routesCoursePrivateCoachingModule from "@/router/Course/PrivateCoachingModule";
import CourseGroupCoachingDefaultView from "@/views/App/Course/GroupCoaching/CourseGroupCoachingDefaultView.vue";
import routesCourseGroupCoaching from "@/router/Course/GroupCoaching";
import routesCoursePrivateLeaningCoaching from "@/router/Course/PrivateLearningCoaching";
import CoursePrivateLearningCoachingDefaultView
    from "@/views/App/Course/PrivateLearningCoaching/CoursePrivateLearningCoachingDefaultView.vue";
import CoursePrivateLearningCoachingModuleDefaultView
    from "@/views/App/Course/PrivateLearningCoachingModule/CoursePrivateLearningCoachingModuleDefaultView.vue";
import routesCoursePrivateLearningCoachingModule from "@/router/Course/PrivateLearningCoachingModule";
import routesUser from "@/router/User";
import UserDefaultView from "@/views/App/User/UserDefaultView.vue";
import HolidayDefaultView from "@/views/App/Holiday/HolidayDefaultView.vue";
import routesHoliday from "@/router/Holiday";
import routesUnemployed from "./Unemployed";
import CoachingOverviewDefaultView from "@/views/App/CoachingOverview/CoachingOverviewDefaultView.vue";
import routesCoachingOverview from "@/router/CoachingOverview";
import routesPortalPrivateCoaching from "@/router/Portal/PrivateCoaching";
import PortalPrivateCoachingDefaultView from "@/views/App/Portal/PrivateCoaching/PortalPrivateCoachingDefaultView.vue";
import PortalGroupCoachingDefaultView from "@/views/App/Portal/GroupCoaching/PortalGroupCoachingDefaultView.vue";
import routesPortalGroupCoaching from "@/router/Portal/GroupCoaching";
import PortalSocioTherapyCoachingDefaultView
    from "@/views/App/Portal/SocioTherapyCoaching/PortalSocioTherapyCoachingDefaultView.vue";
import routesPortalSocioTherapyCoaching from "@/router/Portal/SocioTherapyCoaching";
import PortalAssistedLivingCoachingDefaultView
    from "@/views/App/Portal/AssistedLivingCoaching/PortalAssistedLivingCoachingDefaultView.vue";
import routesPortalAssistedLivingCoaching from "@/router/Portal/AssistedLivingCoaching";
import PortalCaseManagementCoachingDefaultView
    from "@/views/App/Portal/CaseManagementCoaching/PortalCaseManagementCoachingDefaultView.vue";
import routesPortalCaseManagementCoaching from "@/router/Portal/CaseManagementCoaching";
import BillingDefaultView from "@/views/App/Billing/BillingDefaultView.vue";
import routesBilling from "@/router/Billing";
import routesUnemployedOverview from "./Unemployed/indexOverview";
import Storybook from "@/views/Storybook/Storybook.vue";
import {formatRole} from "@/shared/functions";
import {UserRole} from "@/shared/enums/UserRolesEnums";
import {piniaUserStore} from "@/store/piniaUserStore";
import {toRaw, watch} from "vue";
import {piniaEnumsStore} from "@/store/piniaEnumsStore";
import DashboardAccountant from "@/views/App/Dashboard/Accountant/DashboardAccountant.vue";
import DashboardSiteManager from "@/views/App/Dashboard/SiteManager/DashboardSiteManager.vue";
import DashboardSiteSupport from "@/views/App/Dashboard/SiteSupport/DashboardSiteSupport.vue";
import DashboardPracticeManager from "@/views/App/Dashboard/PracticeManager/DashboardPracticeManager.vue";

import OfficeAuditDefaultView from "@/views/App/OfficeAudit/OfficeAuditDefaultView.vue";
import routesOfficeAudit from "@/router/OfficeAudit";
import DashboardHeadAMDL from "@/views/App/Dashboard/HeadAMDL/DashboardHeadAMDL.vue";
import routesDashboardHeadAMDL from "./Dashboard/HeadAMDL";
import DashboardHeadMarketing from "@/views/App/Dashboard/HeadMarketing/DashboardHeadMarketing.vue";
import DashboardHeadOccupationalTherapy
    from "@/views/App/Dashboard/HeadOccupationalTherapy/DashboardHeadOccupationalTherapy.vue";
import routesDashboardHeadOccupationalTherapy from "./Dashboard/HeadOccupationalTherapy";
import routesDashboardSiteManager from "./Dashboard/SiteManager";
import routesDashboardHeadPsychosocialServices from "./Dashboard/HeadPsychosocialServices";
import DashboardHeadPsychosocialServices
    from "@/views/App/Dashboard/HeadPsychosocialServices/DashboardHeadPsychosocialServices.vue";
import TravelExpensesDefaultView from "@/views/App/TravelExpenses/TravelExpensesDefaultView.vue";
import routesTravelExpenses from "@/router/TravelExpenses";
import routesDashboardPracticeManager from "./Dashboard/PracticeManager";
import CoachBillingDefaultView from "@/views/App/CoachBilling/CoachBillingDefaultView.vue";
import routesCoachBilling from "@/router/CoachBilling";
import AiDocumentScanDefaultView from "@/views/App/AiDocumentScan/AiDocumentScanDefaultView.vue";
import PortalPrivateLearningCoachingDefaultView
    from "@/views/App/Portal/PrivateLearningCoaching/PortalPrivateLearningCoachingDefaultView.vue";
import routesPortalPrivateLearningCoaching from "@/router/Portal/PrivateLearningCoaching";
import routesAnalytics from "./Analytics";
import ReportSickDaysDefaultView from "@/views/App/ReportSickDays/ReportSickDaysDefaultView.vue";
import routesReportSickDays from "@/router/ReportSickDays";
import routesUnemployedInquiryOverview from "@/router/Unemployed/indexInquiryOverview";
import routesSecurity from "@/router/Security";
import routesDeletedRecords from "@/router/DeletedRecords";
import routesDashboardAccountant from "@/router/Dashboard/Accountant";
import CourseAssistedLivingCoachingDefaultView
    from "@/views/App/Course/AssistedLivingCoaching/CourseAssistedLivingCoachingDefaultView.vue";
import routesCourseAssistedLivingCoaching from "@/router/Course/AssistedLivingCoaching";
import CourseSocioTherapyCoachingDefaultView
    from "@/views/App/Course/SocioTherapyCoaching/CourseSocioTherapyCoachingDefaultView.vue";
import routesCourseSocioTherapyCoaching from "@/router/Course/SocioTherapyCoaching";
import CronExecutionList from "@/views/App/SystemMonitoring/CronExecution/List.vue";
import SystemExceptionLogList from "@/views/App/SystemMonitoring/SystemExceptionLog/List.vue";
import MessengerExecutionLogList from "@/views/App/SystemMonitoring/MessengerExecutionLog/List.vue";
import CompanySettingsForm from "@/views/App/CompanySettings/Form.vue";
import OnlineUsers from "@/views/App/OnlineUsers/List.vue";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {
    applyDynamicPrimaryColor,
    applyDynamicSidebarColor,
    applyDynamicSidebarIconColor,
    applyDynamicSidebarLinkColor
} from "@/shared/utils/ThemeUtils";
import BlankView from "@/components/BlankView.vue";
import routesPortalPrivateCoachingRemoteSignature from "@/router/Portal/PrivateCoaching/remote_signature";
import routesPortalCMCRemoteSignature from "@/router/Portal/CaseManagementCoaching/remote_signature";
import bbqRoutesPortalPrivateCoaching from "@/router/Portal/PrivateCoaching/bbq_routes";

let shouldScrollToTop = false;

const routes = [
    {
        path: "/",
        component: DefaultView,
        children: [
            // Dashboard
            {
                path: "",
                name: "home",
                component: HomeView,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "dashboard",
                name: "dashboard-admin",
                component: Dashboard,
                children: routesDashboardAdmin,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "dashboard",
                name: "dashboard-therapist",
                component: DashboardCoach,
                meta: {roles: [UserRole.ADMIN, UserRole.COACH, UserRole.THERAPIST]},
            },
            {
                path: "dashboard",
                name: "dashboard-coach",
                component: DashboardCoach,
                meta: {roles: [UserRole.ADMIN, UserRole.COACH, UserRole.THERAPIST]},
            },
            {
                path: "dashboard",
                name: "dashboard-assistant_vq",
                component: DashboardAssistantVQ,
                meta: {roles: [UserRole.ADMIN, UserRole.ASSISTANT_VQ]},
            },
            {
                path: "dashboard",
                name: "dashboard-personal",
                component: DashboardPersonal,
                children: routesDashboardPersonal,
                meta: {roles: [UserRole.ADMIN, UserRole.PERSONAL, UserRole.HEAD_OF_HR]},
            },
            {
                path: "dashboard",
                name: "dashboard-head_of_hr",
                component: DashboardPersonal,
                children: routesDashboardPersonal,
                meta: {roles: [UserRole.ADMIN, UserRole.PERSONAL, UserRole.HEAD_OF_HR]},
            },
            {
                path: "dashboard",
                name: "dashboard-accountant",
                component: DashboardAccountant,
                children: routesDashboardAccountant,
                meta: {roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]},
            },
            {
                path: "dashboard",
                name: "dashboard-head_of_amdl",
                component: DashboardHeadAMDL,
                children: routesDashboardHeadAMDL,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_AMDL]},
            },
            {
                path: "dashboard",
                name: "dashboard-head_of_marketing",
                component: DashboardHeadMarketing,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_MARKETING]},
            },
            {
                path: "dashboard",
                name: 'dashboard-head_of_occupational_therapy',
                component: DashboardHeadOccupationalTherapy,
                children: routesDashboardHeadOccupationalTherapy,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_OCCUPATIONAL_THERAPY]},
            },
            {
                path: "dashboard",
                name: 'dashboard-head_of_psychosocial_services',
                component: DashboardHeadPsychosocialServices,
                children: routesDashboardHeadPsychosocialServices,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES]},
            },
            {
                path: "dashboard",
                name: 'dashboard-site_manager',
                component: DashboardSiteManager,
                children: routesDashboardSiteManager,
                meta: {roles: [UserRole.ADMIN, UserRole.SITE_MANAGER]},
            },
            {
                path: "dashboard",
                name: 'dashboard-site_support',
                component: DashboardSiteSupport,
                meta: {roles: [UserRole.ADMIN, UserRole.SITE_SUPPORT]},
            },
            {
                path: "dashboard",
                name: 'dashboard-practice_manager',
                component: DashboardPracticeManager,
                children: routesDashboardPracticeManager,
                meta: {roles: [UserRole.ADMIN, UserRole.PRACTICE_MANAGER]},
            },
            {
                path: "calendar",
                name: "calendar",
                component: Calendar,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
            },
            {
                path: "holiday",
                component: HolidayDefaultView,
                children: routesHoliday,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
            },
            {
                path: "time-management",
                component: TimeManagementDefaultView,
                children: routesTimeManagement,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
            },
            {
                path: "report-sick-days",
                component: ReportSickDaysDefaultView,
                children: routesReportSickDays,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
            },
            {
                path: "travel-expenses",
                component: TravelExpensesDefaultView,
                children: routesTravelExpenses
            },
            {
                path: "course-private-coaching",
                component: CoursePrivateCoachingDefaultView,
                children: routesCoursePrivateCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.PRACTICE_MANAGER,
                    ]
                },
            },
            {
                path: "course-private-coaching-module",
                component: CoursePrivateCoachingModuleDefaultView,
                children: routesCoursePrivateCoachingModule,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.PRACTICE_MANAGER,
                    ]
                },
            },
            {
                path: "course-group-coaching",
                component: CourseGroupCoachingDefaultView,
                children: routesCourseGroupCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.PRACTICE_MANAGER,
                    ]
                },
            },
            {
                path: "course-private-learning-coaching",
                component: CoursePrivateLearningCoachingDefaultView,
                children: routesCoursePrivateLeaningCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
            },
            {
                path: "course-private-learning-coaching-module",
                component: CoursePrivateLearningCoachingModuleDefaultView,
                children: routesCoursePrivateLearningCoachingModule,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
            },
            {
                path: "course-assisted-living-coaching",
                component: CourseAssistedLivingCoachingDefaultView,
                children: routesCourseAssistedLivingCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
            },
            {
                path: "course-socio-therapy-coaching",
                component: CourseSocioTherapyCoachingDefaultView,
                children: routesCourseSocioTherapyCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.ACCOUNTANT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
            },
            {
                path: "office",
                component: OfficeDefaultView,
                children: routesOffice,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.SITE_MANAGER,
                        UserRole.ASSISTANT_VQ
                    ]
                },
            },
            {
                path: "audit",
                component: OfficeAuditDefaultView,
                children: routesOfficeAudit,
                roles: [
                    UserRole.ADMIN,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.PRACTICE_MANAGER,
                    UserRole.SITE_MANAGER,
                    UserRole.ASSISTANT_VQ
                ],
            },
            {
                path: "region",
                component: RegionDefaultView,
                children: routesRegion,
                meta: {
                    roles: [ // Exclude site manager
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.ASSISTANT_VQ
                    ],
                },
            },
            {
                path: "meeting-room",
                component: MeetingRoomDefaultView,
                children: routesMeetingRoom,
                meta: {
                    roles: [ // Exclude site manager
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.ASSISTANT_VQ
                    ],
                },
            },
            {
                path: "client",
                component: ClientDefaultView,
                children: routesClient,
                roles: [
                    UserRole.ADMIN,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                    UserRole.PRACTICE_MANAGER,
                    UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ACCOUNTANT,
                    UserRole.ASSISTANT_VQ,
                ],
            },
            {
                path: "address-book",
                component: AddressBookDefaultView,
                children: routesAddressBook,
                roles: [
                    UserRole.ADMIN,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.PERSONAL,
                    UserRole.HEAD_OF_HR,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.PRACTICE_MANAGER,
                    UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                    UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                    UserRole.ACCOUNTANT,
                    UserRole.ASSISTANT_VQ,
                ],
            },
            {
                path: "unemployed",
                component: UnemployedDefaultView,
                children: routesUnemployed,
                roles: [
                    UserRole.ADMIN,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                    UserRole.PRACTICE_MANAGER,
                    UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.ACCOUNTANT,
                    UserRole.ASSISTANT_VQ,
                ]
            },
            {
                path: "unemployed/overview",
                component: UnemployedDefaultView,
                // children: routesUnemployedPrivateCoaching,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ACCOUNTANT,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
                children: routesUnemployedOverview
            },
            {
                path: "unemployed/inquiry-overview",
                component: UnemployedDefaultView,
                children: routesUnemployedInquiryOverview,
                roles: [
                    UserRole.ADMIN,
                    UserRole.ACCOUNTANT,
                    UserRole.HEAD_OF_AMDL,
                    UserRole.HEAD_OF_MARKETING,
                    UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                    UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                    UserRole.SITE_MANAGER,
                    UserRole.SITE_SUPPORT
                ]
            },
            {
                path: "user",
                component: UserDefaultView,
                children: routesUser,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PERSONAL,
                        UserRole.HEAD_OF_HR,
                        UserRole.SITE_MANAGER,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.ACCOUNTANT
                    ]
                },
            },
            {
                path: "coaching-overview",
                component: CoachingOverviewDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: routesCoachingOverview,
            },
            // PORTAL
            {
                path: "portal/private-coaching",
                component: PortalPrivateCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: [
                    ...routesPortalPrivateCoaching,
                    ...bbqRoutesPortalPrivateCoaching
                ]
            },
            {
                path: "portal/group-coaching",
                component: PortalGroupCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: routesPortalGroupCoaching
            },
            {
                path: "portal/socio-therapy-coaching",
                component: PortalSocioTherapyCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: routesPortalSocioTherapyCoaching
            },
            {
                path: "portal/assisted-living-coaching",
                component: PortalAssistedLivingCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.HEAD_OF_OCCUPATIONAL_THERAPY,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: routesPortalAssistedLivingCoaching
            },
            {
                path: "portal/case-management-coaching",
                component: PortalCaseManagementCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                        UserRole.ACCOUNTANT,
                        UserRole.ASSISTANT_VQ,
                    ]
                },
                children: routesPortalCaseManagementCoaching
            },
            {
                path: "portal/private-learning-coaching",
                component: PortalPrivateLearningCoachingDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.COACH,
                        UserRole.THERAPIST,
                        UserRole.SITE_MANAGER,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_MARKETING,
                        UserRole.ASSISTANT_VQ,
                        UserRole.ACCOUNTANT,
                    ]
                },
                children: routesPortalPrivateLearningCoaching
            },

            // Billing
            {
                path: "billing",
                component: BillingDefaultView,
                children: routesBilling,
                meta: {roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.ASSISTANT_VQ]},
            },
            // Coach Billing
            {
                path: "coach-billing",
                component: CoachBillingDefaultView,
                children: routesCoachBilling,
                meta: {roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.COACH, UserRole.ASSISTANT_VQ]},
            },
            ...routesAnalytics,
            // {
            //     path: "coach-billing/coordinator",
            //     component: CoachBillingDefaultView,
            //     children: routesCoachBilling,
            //     meta: {roles: [UserRole.COACH]},
            // },

            ...routesDeletedRecords,
            {
                path: "send-email",
                component: SendEmailDefaultView,
                children: routesSendEmail,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "ai-document-scan",
                name: "aiDocumentScan",
                component: AiDocumentScanDefaultView,
                meta: {
                    roles: [
                        UserRole.ADMIN,
                        UserRole.PRACTICE_MANAGER,
                        UserRole.SITE_MANAGER,
                        UserRole.HEAD_OF_AMDL,
                        UserRole.SITE_SUPPORT,
                        UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES
                    ]
                },
            },
            {
                path: "/company-settings",
                name: 'companySettings',
                component: CompanySettingsForm,
                meta: {roles: [UserRole.ADMIN]}
            },
            {
                path: "/cron-execution/list",
                name: 'cronExecutionList',
                component: CronExecutionList,
                meta: {roles: [UserRole.ADMIN]}
            },
            {
                path: "/system-exception-log/list",
                name: 'systemExceptionLogList',
                component: SystemExceptionLogList,
                meta: {roles: [UserRole.ADMIN]}
            },
            {
                path: "/messenger-execution-log/list",
                name: 'messengerExecutionLogList',
                component: MessengerExecutionLogList,
                meta: {roles: [UserRole.ADMIN]}
            },
            {
                path: "/online-users",
                name: 'onlineUsers',
                component: OnlineUsers,
                meta: {roles: [UserRole.ADMIN]}
            },
            {
                path: "storybook",
                component: Storybook,
            },
            {
                path: "security",
                children: routesSecurity,
                component: UserDefaultView
            },
        ],
    },
    {
        path: "/auth",
        name: "auth",
        component: SecurityView,
        children: routesAuth,
    },

    {  // Public routes
        path: "/public/portal",
        component: BlankView,
        children: [
            ...routesPortalPrivateCoachingRemoteSignature,
            ...routesPortalCMCRemoteSignature
        ],
    },

    {path: "/:pathMatch(.*)*", redirect: "/dashboard"},
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // history: createMemoryHistory(),
    routes,
});


const publicRoutes = [
    '/auth/new-password',
    '/auth/forgot-password',
    '/public/portal/private-coaching/remote-meetings',
    '/public/portal/case-management-coaching/remote-meetings'
];

router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('token');
    const userStore = piniaUserStore();
    const piniaEnumsState = piniaEnumsStore();
    const companySettingsStore = piniaCompanySettingsStore()

    if (!userStore.currentUser.user && localStorage.getItem("token")) {
        await userStore.piniaGetUser();
    }

    if (!piniaEnumsState.enums && localStorage.getItem("token")) {
        await piniaEnumsState.getEnums();
    }

    if (!companySettingsStore.companySettings && localStorage.getItem("token")) {
        await companySettingsStore.getCompanySettings();
    }

    watch(
        () => companySettingsStore?.companySettings?.colorCode,
        (newColor) => {
            if (newColor) applyDynamicPrimaryColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarColorCode,
        (newColor) => {
            if (newColor) applyDynamicSidebarColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarIconColorCode,
        (newColor) => {
            if (newColor) applyDynamicSidebarIconColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarLinkColorCode,
        (newColor) => {
            if (newColor) applyDynamicSidebarLinkColor(newColor);
        }
    );

    const rawRoles = toRaw(userStore.currentUser).user?.roles || [];
    const routeRoles = to.meta?.roles as string[];


    const isPublicRoute = publicRoutes.some(route =>
        to.path.startsWith(route)
    );

    if (!token && to.name !== 'login' && !isPublicRoute) {
        await router.push({ name: 'login' });
    }

    // if (!token && (to?.name as string) !== 'login') {
    //     if (!publicRoutes.includes(to?.path as string)) {
    //         await router.push({name: 'login'});
    //     }
    // }

    // Redirect to log in if not authenticated
    // if (to.name !== "login" && !localStorage.getItem("token")) {
    //     if (to.name !== 'forgotPassword') {
    //         return next({name: "login"});
    //     }
    // }

    if (routeRoles && !routeRoles.includes(rawRoles[0])) {
        // if (to.name === "dashboard") {
        // return next(false);
        // }
        return next({name: `dashboard-${formatRole(rawRoles[0])}`});
    }

    // Set flag to scroll after successful navigation
    shouldScrollToTop = true;
    next();
});

router.afterEach(() => {
    if (shouldScrollToTop) {
        window.scrollTo({top: 0, behavior: "smooth"});
        shouldScrollToTop = false;
    }
});

export default router;
